'use client';

import { c as _c } from "react/compiler-runtime";
import SvgAdd from '@common/icon/SvgAdd';
import SvgBenefitFill from '@common/icon/SvgBenefitFill';
import SvgMyFill from '@common/icon/SvgMyFill';
import SvgShoppingBasketFill from '@common/icon/SvgShoppingBasketFill';
import SvgStore from '@common/icon/SvgStore';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { ROUTES, WEL_MARKET_ROUTES } from '@/constants';
import { useHaptic } from '@/hooks/useHaptic';
const ANIMATION_DURATION = 300;
type LocalMarketBnbLinkItem = {
  kind: 'link';
  label: string;
  route: {
    pathname: string;
  };
  icon: typeof SvgStore;
};
type LocalMarketBnbItem = LocalMarketBnbLinkItem;
const LOCAL_MARKET_BNB_ITEMS: readonly LocalMarketBnbItem[] = [{
  kind: 'link',
  label: '홈',
  route: WEL_MARKET_ROUTES.HOME,
  icon: SvgStore
}, {
  kind: 'link',
  label: '장바구니',
  route: WEL_MARKET_ROUTES.CART,
  icon: SvgShoppingBasketFill
}, {
  kind: 'link',
  label: '혜택',
  route: ROUTES.BENEFIT,
  icon: SvgBenefitFill
}, {
  kind: 'link',
  label: '마이페이지',
  route: ROUTES.MY,
  icon: SvgMyFill
}];
export const LocalMarketBnb = () => {
  const $ = _c(25);
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [menuClickAnimated, setMenuClickAnimated] = useState(t0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    triggerHaptic
  } = useHaptic();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = index => {
      setMenuClickAnimated(prev => ({
        ...prev,
        [index]: true
      }));
      setTimeout(() => {
        setMenuClickAnimated(prev_0 => ({
          ...prev_0,
          [index]: false
        }));
      }, ANIMATION_DURATION);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleMenuClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDropdownOpen(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isDropdownOpen) {
    t3 = cn("size-20 text-Gray-600 transition-transform duration-200", {
      "rotate-45": isDropdownOpen
    });
    $[3] = isDropdownOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <SvgAdd className={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isDropdownOpen || $[8] !== t4) {
    t5 = <button type="button" className="relative z-50 size-40 rounded-pill bg-Gray-200 flex-center" onClick={t2} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}>{t4}</button>;
    $[7] = isDropdownOpen;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsDropdownOpen(false);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isDropdownOpen) {
    t7 = <ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={t6} currentService="market" />;
    $[11] = isDropdownOpen;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div className="relative z-50">{t5}{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== menuClickAnimated || $[17] !== pathname || $[18] !== triggerHaptic) {
    t9 = LOCAL_MARKET_BNB_ITEMS.map((item, index_0) => {
      const itemAnimationStyle = {
        animationDuration: `${ANIMATION_DURATION}ms`
      } as const;
      const Icon = item.icon;
      const isActive = (() => {
        if (!pathname) {
          return false;
        }
        if (item.route.pathname === WEL_MARKET_ROUTES.HOME.pathname) {
          return pathname === item.route.pathname;
        }
        return pathname.includes(item.route.pathname);
      })();
      const isCurrentPage = pathname === item.route.pathname;
      return <li key={item.label} className="w-53"><CustomLink href={item.route.pathname} aria-label={`${item.label} 페이지로 이동`} prefetch={true} className={cn("flex w-full flex-col items-center", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle} onClick={() => {
          if (!isCurrentPage) {
            triggerHaptic();
          }
          handleMenuClick(index_0);
        }}><Icon className={cn("size-28 text-Gray-400", {
            "text-Gray-black": isActive
          })} /><p className={cn("whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2", {
            "font-600 text-Gray-900": isActive
          })}>{item.label}</p></CustomLink></li>;
    });
    $[16] = menuClickAnimated;
    $[17] = pathname;
    $[18] = triggerHaptic;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <ul className="flex flex-1 items-center justify-around px-12">{t9}</ul>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <nav aria-label={"\uC6F0\uB9C8\uCF19 \uB0B4\uBE44\uAC8C\uC774\uC158"} className="relative flex size-full items-center p-8">{t8}{t10}</nav>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
function _temp(prev_1) {
  return !prev_1;
}